{
  "labels": [
    "background",
    "tissue",
    "bone",
    "skin",
    "connective tissue",
    "blood",
    "organ",
    "mass",
    "muscle",
    "foreign object",
    "waste",
    "teeth",
    "fat",
    "gray matter",
    "white matter",
    "nerve",
    "vein",
    "artery",
    "capillary",
    "ligament",
    "tendon",
    "cartilage",
    "meniscus",
    "lymph node",
    "lymphatic vessel",
    "cerebro-spinal fluid",
    "bile",
    "urine",
    "feces",
    "gas",
    "fluid",
    "edema",
    "bleeding",
    "necrosis",
    "clot",
    "embolism",
    "head",
    "central nervous system",
    "brain",
    "gray matter of brain",
    "telencephalon",
    "cerebral cortex",
    "right frontal lobe",
    "left frontal lobe",
    "right temporal lobe",
    "left temporal lobe",
    "right parietal lobe",
    "left parietal lobe",
    "right occipital lobe",
    "left occipital lobe",
    "right insular lobe",
    "left insular lobe",
    "right limbic lobe",
    "left limbic lobe",
    "right striatum",
    "left striatum",
    "right caudate nucleus",
    "left caudate nucleus",
    "right putamen",
    "left putamen",
    "right pallidum",
    "left pallidum",
    "right amygdaloid complex",
    "left amygdaloid complex",
    "diencephalon",
    "thalamus",
    "right thalamus",
    "left thalamus",
    "pineal gland",
    "midbrain",
    "substantia nigra",
    "right substantia nigra",
    "left substantia nigra",
    "cerebral white matter",
    "right superior longitudinal fasciculus",
    "left superior longitudinal fasciculus",
    "right inferior longitudinal fasciculus",
    "left inferior longitudinal fasciculus",
    "right arcuate fasciculus",
    "left arcuate fasciculus",
    "right uncinate fasciculus",
    "left uncinate fasciculus",
    "right cingulum bundle",
    "left cingulum bundle",
    "projection fibers",
    "right corticospinal tract",
    "left corticospinal tract",
    "right optic radiation",
    "left optic radiation",
    "right medial lemniscus",
    "left medial lemniscus",
    "right superior cerebellar peduncle",
    "left superior cerebellar peduncle",
    "right middle cerebellar peduncle",
    "left middle cerebellar peduncle",
    "right inferior cerebellar peduncle",
    "left inferior cerebellar peduncle",
    "optic chiasm",
    "right optic tract",
    "left optic tract",
    "right fornix",
    "left fornix",
    "commissural fibers",
    "corpus callosum",
    "posterior commissure",
    "cerebellar white matter",
    "CSF space",
    "ventricles of brain",
    "right lateral ventricle",
    "left lateral ventricle",
    "right third ventricle",
    "left third ventricle",
    "cerebral aqueduct",
    "fourth ventricle",
    "subarachnoid space",
    "spinal cord",
    "gray matter of spinal cord",
    "white matter of spinal cord",
    "endocrine system of brain",
    "pituitary gland",
    "adenohypophysis",
    "neurohypophysis",
    "meninges",
    "dura mater",
    "arachnoid",
    "pia mater",
    "muscles of head",
    "salivary glands",
    "lips",
    "nose",
    "tongue",
    "soft palate",
    "right inner ear",
    "left inner ear",
    "right external ear",
    "left external ear",
    "right middle ear",
    "left middle ear",
    "right eyeball",
    "left eyeball",
    "skull",
    "right frontal bone",
    "left frontal bone",
    "right parietal bone",
    "left parietal bone",
    "right temporal bone",
    "left temporal bone",
    "right sphenoid bone",
    "left sphenoid bone",
    "right ethmoid bone",
    "left ethmoid bone",
    "occipital bone",
    "maxilla",
    "right zygomatic bone",
    "right lacrimal bone",
    "vomer bone",
    "right palatine bone",
    "left palatine bone",
    "mandible",
    "neck",
    "muscles of neck",
    "pharynx",
    "larynx",
    "thyroid gland",
    "right parathyroid glands",
    "left parathyroid glands",
    "skeleton of neck",
    "hyoid bone",
    "cervical vertebral column",
    "thorax",
    "trachea",
    "bronchi",
    "right lung",
    "left lung",
    "superior lobe of right lung",
    "superior lobe of left lung",
    "middle lobe of right lung",
    "inferior lobe of right lung",
    "inferior lobe of left lung",
    "pleura",
    "heart",
    "right atrium",
    "left atrium",
    "atrial septum",
    "ventricular septum",
    "right ventricle of heart",
    "left ventricle of heart",
    "mitral valve",
    "tricuspid valve",
    "aortic valve",
    "pulmonary valve",
    "aorta",
    "pericardium",
    "pericardial cavity",
    "esophagus",
    "thymus",
    "mediastinum",
    "skin of thoracic wall",
    "muscles of thoracic wall",
    "skeleton of thorax",
    "thoracic vertebral column",
    "ribs",
    "sternum",
    "right clavicle",
    "left clavicle",
    "abdominal cavity",
    "abdomen",
    "peritoneum",
    "omentum",
    "peritoneal cavity",
    "retroperitoneal space",
    "stomach",
    "duodenum",
    "small bowel",
    "colon",
    "anus",
    "liver",
    "biliary tree",
    "gallbladder",
    "pancreas",
    "spleen",
    "urinary system",
    "right kidney",
    "left kidney",
    "right ureter",
    "left ureter",
    "urinary bladder",
    "urethra",
    "right adrenal gland",
    "left adrenal gland",
    "female internal genitalia",
    "uterus",
    "right fallopian tube",
    "left fallopian tube",
    "right ovary",
    "left ovary",
    "vagina",
    "male internal genitalia",
    "prostate",
    "right seminal vesicle",
    "left seminal vesicle",
    "right deferent duct",
    "left deferent duct",
    "skin of abdominal wall",
    "muscles of abdominal wall",
    "skeleton of abdomen",
    "lumbar vertebral column",
    "female external genitalia",
    "male external genitalia",
    "skeleton of upper limb",
    "muscles of upper limb",
    "right upper limb",
    "left upper limb",
    "right shoulder",
    "left shoulder",
    "right arm"
  ],
  "R": [
    0, 128, 241, 177, 111, 216, 221, 144, 192, 220, 78, 255, 230, 200, 250, 244,
    0, 216, 183, 183, 152, 111, 178, 68, 111, 85, 0, 214, 78, 218, 170, 140,
    188, 216, 145, 150, 177, 244, 250, 200, 68, 128, 83, 83, 162, 162, 141, 141,
    182, 182, 188, 188, 154, 154, 177, 177, 30, 30, 210, 210, 48, 48, 98, 98,
    69, 166, 122, 122, 253, 145, 46, 0, 0, 250, 127, 127, 159, 159, 125, 125,
    106, 106, 154, 154, 126, 201, 201, 78, 78, 174, 174, 139, 139, 148, 148,
    186, 186, 99, 156, 156, 64, 64, 138, 97, 126, 194, 85, 88, 88, 88, 88, 88,
    88, 88, 88, 244, 200, 250, 82, 57, 60, 92, 255, 255, 255, 255, 201, 70, 188,
    177, 166, 182, 229, 229, 174, 174, 201, 201, 194, 194, 241, 203, 203, 229,
    229, 255, 255, 209, 209, 248, 248, 255, 196, 255, 255, 255, 242, 242, 222,
    177, 213, 184, 150, 62, 62, 62, 242, 250, 255, 177, 182, 175, 197, 197, 172,
    172, 202, 224, 224, 255, 206, 210, 203, 233, 195, 181, 152, 159, 166, 218,
    225, 224, 255, 184, 211, 47, 255, 173, 188, 255, 226, 253, 244, 205, 205,
    186, 177, 255, 234, 204, 180, 216, 255, 205, 204, 255, 221, 0, 139, 249,
    157, 203, 185, 185, 247, 247, 222, 124, 249, 249, 244, 255, 255, 227, 213,
    213, 193, 216, 230, 245, 245, 241, 241, 177, 171, 217, 212, 185, 185, 198,
    194, 177, 177, 177, 177, 177
  ],
  "G": [
    0, 174, 214, 122, 184, 101, 130, 238, 104, 245, 63, 250, 220, 200, 250, 214,
    151, 101, 156, 214, 189, 184, 212, 172, 197, 188, 145, 230, 63, 255, 250,
    224, 65, 191, 60, 98, 122, 214, 250, 200, 131, 174, 146, 146, 115, 115, 93,
    93, 166, 166, 135, 135, 150, 150, 140, 140, 111, 111, 157, 157, 129, 129,
    153, 153, 110, 113, 101, 101, 135, 92, 101, 108, 108, 250, 150, 150, 116,
    116, 102, 102, 174, 174, 146, 146, 126, 160, 160, 152, 152, 140, 140, 126,
    126, 120, 120, 135, 135, 106, 171, 171, 123, 123, 95, 113, 161, 195, 188,
    106, 106, 106, 106, 106, 106, 106, 106, 214, 200, 250, 174, 157, 143, 162,
    244, 244, 244, 244, 121, 163, 91, 122, 84, 105, 147, 147, 122, 122, 112,
    112, 142, 142, 213, 179, 179, 204, 204, 243, 243, 185, 185, 223, 223, 230,
    172, 255, 250, 237, 217, 217, 198, 122, 124, 105, 208, 162, 162, 162, 206,
    210, 255, 122, 228, 216, 165, 165, 138, 138, 164, 186, 186, 245, 110, 115,
    108, 138, 100, 85, 55, 63, 70, 123, 130, 97, 244, 122, 171, 150, 244, 121,
    95, 239, 202, 232, 217, 179, 179, 124, 122, 255, 234, 142, 119, 132, 253,
    167, 168, 224, 130, 145, 150, 180, 108, 136, 102, 102, 182, 182, 154, 186,
    186, 186, 170, 181, 190, 153, 141, 141, 123, 146, 158, 172, 172, 172, 172,
    124, 85, 198, 188, 135, 135, 175, 98, 122, 122, 122, 122, 122
  ],
  "B": [
    0, 128, 145, 101, 210, 79, 101, 144, 88, 20, 0, 220, 70, 235, 210, 49, 206,
    79, 220, 211, 207, 210, 242, 100, 131, 255, 30, 130, 0, 255, 250, 228, 28,
    216, 66, 83, 101, 49, 225, 215, 98, 128, 164, 164, 105, 105, 137, 137, 110,
    110, 166, 166, 201, 201, 190, 190, 85, 85, 166, 166, 126, 126, 112, 112, 53,
    137, 38, 38, 192, 109, 131, 112, 112, 225, 88, 88, 163, 163, 154, 154, 155,
    155, 83, 83, 55, 133, 133, 141, 141, 103, 103, 177, 177, 72, 72, 135, 135,
    24, 108, 108, 147, 147, 74, 158, 197, 164, 255, 215, 215, 215, 215, 215,
    215, 215, 215, 49, 215, 225, 128, 110, 83, 109, 209, 209, 209, 209, 77, 117,
    95, 101, 94, 107, 118, 118, 90, 90, 73, 73, 0, 0, 144, 77, 77, 109, 109,
    152, 152, 85, 85, 131, 131, 138, 68, 167, 160, 145, 123, 123, 101, 101, 109,
    108, 243, 114, 114, 114, 142, 139, 207, 101, 255, 244, 145, 145, 115, 115,
    140, 162, 162, 217, 84, 89, 81, 112, 73, 57, 13, 27, 38, 97, 104, 76, 209,
    154, 143, 103, 209, 88, 76, 172, 134, 158, 154, 108, 108, 161, 101, 220,
    194, 178, 153, 105, 229, 142, 143, 199, 101, 30, 98, 111, 162, 116, 83, 83,
    164, 164, 132, 223, 150, 150, 147, 158, 165, 130, 113, 113, 103, 127, 140,
    147, 147, 151, 151, 92, 68, 131, 102, 134, 134, 125, 79, 101, 101, 101, 101,
    101
  ],
  "A": [
    0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255
  ],
  "I": [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
    40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
    59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
    78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96,
    97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
    113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
    128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142,
    143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157,
    158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172,
    173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187,
    188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202,
    203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217,
    218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
    233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247,
    248, 249, 250, 251, 252, 253, 254, 255
  ]
}
